import { InfoIcon } from 'components/icons/Info'
import { PageTitle } from 'components/PageTitle'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'

export const EditActivityPage = observer(function EditActivityPage() {
  const { tt } = useTranslationTyped()

  return (
    <main
      data-testid="lti-edit-activity-page"
      className="flex h-full w-full flex-col bg-surface-bright p-10"
    >
      <PageTitle title={tt.lti.page_title()} />
      <div className="flex flex-1 flex-col items-center justify-center rounded-2xl border border-outline-medium bg-core-on-primary">
        <div className="mb-4">
          <InfoIcon className="stroke-core-primary" size={30} />
        </div>
        <div className="flex max-w-[600px] flex-col gap-1 text-center">
          <h1 className="text-title-large text-core-primary">
            {tt.lti.edit_activity.title()}
          </h1>
          <p className="text-body-large text-on-surface-var">
            {tt.lti.edit_activity.description()}
          </p>
        </div>
      </div>
    </main>
  )
})
